export default __webpack_public_path__ + "static/media/tsisterna.c20f445d.svg";